import { httpClient } from '../httpClient';

/**
 * Classification Core API -- CRUD operations + bulk actions.
 * Extracted from classification.js (T117).
 */
export const classificationCoreApi = {
  // ── Core CRUD ──────────────────────────────────────────────────────────
  getAll: (params) =>
    httpClient.get('/classification/', { params }),

  getById: (id) =>
    httpClient.get(`/classification/${id}`),

  update: (id, data) =>
    httpClient.put(`/classification/${id}`, data),

  delete: (id) =>
    httpClient.delete(`/classification/${id}`),

  bulkAction: (data) =>
    httpClient.post('/classification/bulk-action', data),

  exportSelected: (data, config) =>
    httpClient.post('/classification/export/selected', data, config),

  // ── History ────────────────────────────────────────────────────────────
  getVersionHistory: (classificationId) =>
    httpClient.get(`/classification/history/${classificationId}`),

  getRecentChanges: (queryString) =>
    httpClient.get(`/classification/history/changes?${queryString}`),

  getScanLog: (queryString) =>
    httpClient.get(`/classification/history/scan-log?${queryString}`),

  getHistoryEvents: (queryString) =>
    httpClient.get(`/classification/history/events?${queryString}`),

  // ── Export ─────────────────────────────────────────────────────────────
  exportData: (format, queryString) =>
    httpClient.get(`/classification/export/${format}${queryString ? `?${queryString}` : ''}`, { responseType: 'blob' }),

  exportPdf: (format, data, options) =>
    httpClient.post(`/classification/export/${format}`, data, options),

  // ── Feedback ───────────────────────────────────────────────────────────
  getFeedback: (classificationId) =>
    httpClient.get(`/classification/${classificationId}/feedback`),

  submitFeedback: (classificationId, data) =>
    httpClient.post(`/classification/${classificationId}/feedback`, data),

  // ── Tree ───────────────────────────────────────────────────────────────
  getTreeSources: (queryString) =>
    httpClient.get(`/classification/tree/sources?${queryString}`),

  getTreeTables: (sourceId) =>
    httpClient.get(`/classification/tree/tables?source_id=${sourceId}`),

  getTreeColumns: (queryString) =>
    httpClient.get(`/classification/tree/columns?${queryString}`),

  // ── Integration (per-classification) ───────────────────────────────────
  getIntegrationStatus: (classificationId) =>
    httpClient.get(`/classification/${classificationId}/integration`),

  // ── Risk Score ─────────────────────────────────────────────────────────
  getRiskScore: (sourceId) =>
    httpClient.get(`/classification/risk-score/${sourceId}`),

  // ── Transfers ──────────────────────────────────────────────────────────
  getTransfers: (queryString) =>
    httpClient.get(`/classification/transfers?${queryString}`),

  createTransfer: (data) =>
    httpClient.post('/classification/transfers', data),

  updateTransfer: (id, data) =>
    httpClient.put(`/classification/transfers/${id}`, data),

  deleteTransfer: (id) =>
    httpClient.delete(`/classification/transfers/${id}`),
};
